import { render, staticRenderFns } from "./placementScheme.vue?vue&type=template&id=82c4dfa4&"
import script from "./placementScheme.vue?vue&type=script&lang=js&"
export * from "./placementScheme.vue?vue&type=script&lang=js&"
import style0 from "./placementScheme.vue?vue&type=style&index=0&id=82c4dfa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports